// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import './util/lazyLoad'
import initReadMore from './util/readMore'
import initContentLine from './util/contentLine'
import initHotelBlockLines from './util/hotelAccentLine'
import initScrollToTop from './util/backToTop'
import { addressLookup } from './util/addressLookup'
import { FormHelpers } from './util/formHelpers'

import { HeroSlider } from './components/sliders/c-heroSlider'
import { HotelCarouselSlider } from './components/sliders/c-hotelCarousel'
import { RestaurantHeroSlider } from './components/sliders/c-restaurantHeroSlider'
import { RestaurantEventSlider } from './components/sliders/c-restaurantEventSlider'
import { LogoSlider } from './components/sliders/c-logoSlider'
import { RestaurantsBySlider } from './components/sliders/c-restaurantsBySlider'
import { OtherRestaurantsSlider } from './components/sliders/c-otherRestaurants'
import { HotelCardsSlider } from './components/sliders/c-hotelCards'
import { HotelClubPlusCTASlider } from './components/sliders/c-hotelClubCtaSlider'
import SiteSearch from './components/c-site-search'
import EventFilters from './components/c-eventFilters'
import BlogPosts from './components/c-blogPosts'
import HotelFilters from './components/c-hotelFilters'
import RestaurantRooms from './components/c-restaurantRooms'
import RestaurantContactMap from './components/c-restaurant-contact-map'
import SubNavigation from './components/c-subNavigation'
import HotelSubNavigation from './components/c-hotel-subNavigation'
import cookieBar from './components/c-cookie-bar'
import loginModal from './components/c-loginModal'
import registerForm from './components/c-register'
import Header from './components/c-header'
import PromoBanner from './components/c-promo-banner'
import { SchemeForm } from './components/c-scheme'
import { DashboardForms, DashboardSearchFilters } from './components/c-dashboard'
import { Dropdown } from './components/c-dropdown'
import { DownloadAppBanner } from './components/c-download-app-banner'
import initHeroVideoReveal from './util/heroVideoReveal'

// Pages
import { AboutPage } from './pages/about'
import { NewsletterArchivePage } from './pages/newsletter-archive'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

initReadMore()
initContentLine()
initHotelBlockLines()
initScrollToTop()
addressLookup()
FormHelpers()

initHeroVideoReveal()
HeroSlider()
HotelCarouselSlider()
RestaurantHeroSlider()
RestaurantEventSlider()
LogoSlider()
RestaurantsBySlider()
OtherRestaurantsSlider()
HotelCardsSlider()
HotelClubPlusCTASlider()
SubNavigation()
HotelSubNavigation()
RestaurantContactMap()
loginModal()
registerForm()
Header()
PromoBanner()
cookieBar()
SiteSearch()
SchemeForm()
DashboardForms()
DashboardSearchFilters()
Dropdown()
DownloadAppBanner()

// Pages
AboutPage()
NewsletterArchivePage()

new EventFilters()
new HotelFilters()
new BlogPosts()
new RestaurantRooms()

